// Aqui se definen el nombre de la unidad
export const unitTypes = {
  pressure: "pressure",
  temperature: "temperature",
  flow: "flow",
  outputFlow: "outputFlow",
  percentage: "percentage",
  angularSpeed: "angularSpeed",
  power: "power",
  voltage: "voltage",
  frequency: "frequency",
  electricCurrent: "electricCurrent",
  volume: "volume",
  capacity: "capacity",
  pH: "pH",
  conductivity: "conductivity",
  massFlow: "massFlow",
  electricalPower: "electricalPower",
  length: "length",
  vibration: "vibration",
  unique: "unique",
  steps: "steps",
  flameStability: "flameStability",
  flameColor: "flameColor",
  deathLine: "deathLine"
};

// Aqui las diferentes unidades para los selectores
export const unitList = {
  pressure: ["psi", "kPa", "bar", "atm"],
  temperature: ["°F", "°R", "°C", "K"],
  flow: ["GPM", "m³/s", "m³/h", "l/h", "ft³/h", "MMSCFD"],
  outputFlow: ["GPM", "m³/s", "m³/h", "l/h", "ft³/h", "MMSCFD"],
  percentage: ["%", "relative"],
  angularSpeed: ["rpm", "rad/s"],
  power: ["kW", "hp"],
  driver: ["Engine", "Turbine"],
  driven: ["Pump", "Generator"],
  voltage: ["V"],
  frequency: ["Hz"],
  electricCurrent: ["A"],
  volume: ["m³", "l", "gal"],
  capacity: ["ton"],
  pH: ["pH"],
  conductivity: ["μS/cm"],
  massFlow: ["kg/h", "lb/h"],
  electricalPower: ["kVA"],
  length: ["m", "in", "ft"],
  vibration: ["μm", "mils"]
};

//
export const unitDefault = {
  steps: {
    metric: "",
    imperial: ""
  },
  unique: {
    metric: "",
    imperial: ""
  },
  flameStability: {
    metric: "",
    imperial: ""
  },
  flameColor: {
    metric: "",
    imperial: ""
  },
  deathLine: {
    metric: "",
    imperial: ""
  },
  pressure: {
    metric: "bar",
    imperial: "psi"
  },
  temperature: {
    metric: "°C",
    imperial: "°F"
  },
  flow: {
    metric: "l/h",
    imperial: "GPM"
  },
  outputFlow: {
    metric: "l/h",
    imperial: "MMSCFD"
  },
  percentage: {
    metric: "%",
    imperial: "%"
  },
  angularSpeed: {
    metric: "rad/s",
    imperial: "rpm"
  },
  power: {
    metric: "kW",
    imperial: "hp"
  },
  voltage: {
    metric: "V",
    imperial: "V"
  },
  frequency: {
    metric: "Hz",
    imperial: "Hz"
  },
  electricCurrent: {
    metric: "A",
    imperial: "A"
  },
  volume: {
    metric: "l",
    imperial: "gal"
  },
  capacity: {
    metric: "ton",
    imperial: "ton"
  },
  pH: {
    metric: "pH",
    imperial: "pH"
  },
  conductivity: {
    metric: "μS/cm",
    imperial: "μS/cm"
  },
  massFlow: {
    metric: "kg/h",
    imperial: "lb/h"
  },
  electricalPower: {
    metric: "kVA",
    imperial: "kVA"
  },
  length: {
    metric: "m",
    imperial: "in"
  },
  vibration: {
    metric: "μm",
    imperial: "mils"
  }
};

export const timeJump = {
  year: { name: "year", value: 31536000 },
  month: { name: "month", value: 2592000 },
  day: { name: "day", value: 86400 },
  minute: { name: "minute", value: 60 },
  second: { name: "second", value: 1 }
};
